import '../styles/cta.scss';
import ctaEnfamilLogo from '../assets/ctaEnfamilLogo.png';
import enfamilLogo from '../assets/enfamilLogo.png';
import useWidthSetter from '../CustomHooks/useWidthSetter';

const Cta = () => {
  let width = useWidthSetter();
  return (
    <div className="cta">
      <div className="cta__logo">
        <img src={width > 800 ? ctaEnfamilLogo : enfamilLogo} alt="enfamil logo" />
      </div>
      <div className="cta__info">
        <p>
          Access additional information and resources to help you navigate the current shortage.
        </p>
        <a href="https://www.enfamil.com/enfamil-formula-supply/" target="_blank" rel="noreferrer">
          <button>Explore Now</button>
        </a>
      </div>
    </div>
  );
};

export default Cta;
